import { Outlet, Link } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-off-white flex flex-col">
      {/* Header */}
      <header className="py-6 px-4">
        <div className="container mx-auto">
          <Link to="/" className="inline-block">
            <h1 className="text-2xl font-heading tracking-[0.2em] text-luxury-dark">
              KULUM
            </h1>
          </Link>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 px-4 text-center text-sm text-neutral-500">
        <p>&copy; {new Date().getFullYear()} KULUM. All rights reserved.</p>
      </footer>
    </div>
  );
}
